 <!--===== WORK =====-->
<section class="work section" id="work">
   <h2 class="section-title">Projects</h2>
   <div class="work__container bd-grid">
       <div [ngsReveal]="getOptions()" *ngFor="let project of projects" class="work__img">
           <img (click)="open(project)" src="{{project.img}}" alt="{{project.name}}">
       </div>
   </div>
</section>
